import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";
import Btn from "../button/Btn";
import CustomTooltip from "../CustomTooltip";

const CustomDropdown = ({
  listProps = {},
  variant = "outline-primary",
  id = "custom-dropdown",
  overlayText,
  overlayPosition = "top", // tooltip side for overlayText
  header,
  as = Btn, // custom button
  options = [], // menu items
  onSelect = () => { }, // callback for selection
  dropdownProps = {}, // parent <Dropdown> props
  toggleProps = {}, // <Dropdown.Toggle> props
  menuProps = {}, // <Dropdown.Menu> props
  itemProps = {}, // default item props
}) => {
  const toggle = (
    <Dropdown.Toggle variant={variant} id={id} as={as} {...toggleProps} />
  );
  return (
    <Dropdown onSelect={onSelect} {...dropdownProps}>
      {overlayText ? <CustomTooltip content={overlayText} position={overlayPosition}>
        {toggle}
      </CustomTooltip> : toggle}
      <Dropdown.Menu {...menuProps}>
        {header && (
          <Dropdown.Header className="fs-xxs fw-bold text-muted text-uppercase px-3 mb-1">
            {header}
          </Dropdown.Header>
        )}
        <div {...listProps}>
          {options.map((opt, i) => {
            if (opt.divider) {
              return <Dropdown.Divider key={i} />;
            }
            return (
              <Dropdown.Item
                key={i}
                eventKey={opt.value}
                disabled={opt.disabled}
                className={`d-flex align-items-center gap-4 ${opt.className || ""}`}
                {...opt}
                {...itemProps}
              >
                {opt?.icon && <i className="lh-1 flex-center">{opt.icon}</i>}
                {opt.label}
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(CustomDropdown);
